// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2iJae","play":"button_play__3cdpM","disabled":"button_disabled__2pFUC","blocked":"button_blocked__n6oza","loading":"button_loading__3hlVQ"};